export default "__VITE_ASSET__BmR52t7g__"